<p-toast />
<app-header-krismar class="d_header" id="d_header" />
<app-login-page></app-login-page>
<section class="d_section">
    <app-carrucel class="d_principal d_section_home" *ngIf="!viewCarrucel "></app-carrucel>

    <!-- componente que muestra las aplicaciones más recientes -->
    <app-recientes *ngIf="false" id="lo_mas_reciente" [dataAplicaciones]="_conf.recientes"
        class="d_principal d_section_actividades onShow"></app-recientes>

    <!-- componente que muestra las asignaturas -->
    <app-asignaturas *ngIf="!viewComponentes && existenDatos && viewAsignaturas" id="asignaturas_component"
        class="d_principal d_section_asignaturas" [dataAsignaturas]="_conf.dataGlobalFiltrada?.asignaturas"
        [filtroSelecionados]="_conf.filters"> </app-asignaturas>

    <!-- componente que muestra los grados -->
    <app-grados *ngIf="!viewComponentes && existenDatos && viewGrados" id="grados_component"
        class="d_principal d_section_grados" [dataGrados]="_conf.dataGlobalFiltrada?.grados"
        [filtroSelecionados]="_conf.filters"> </app-grados>

    <!-- Componente que muestra los filtros -->
    <app-filtros class="d_principal d_section_navsearch" *ngIf="viewComponentes || !existenDatos"
        [dataLocal]="_conf.dataGlobal" [dataGrados]="_conf.dataGlobalFiltrada?.grados"
        [dataAsignaturas]="_conf.dataGlobalFiltrada?.asignaturas"
        [dataAplicaciones]="_conf.dataGlobalFiltrada?.aplicaciones ?? []"> </app-filtros>
    <!-- Componente que muestra las actividades filtradas -->
    <app-actividades-filtradas *ngIf="viewComponentes || !existenDatos"
        [dataAplicaciones]="_conf.dataGlobalFiltrada?.aplicaciones ?? []"
        class="d_principal d_section_actividades_filtradas">
    </app-actividades-filtradas>


    <!-- Listado dinámico de enlaces -->
    <app-listado-dinamico [_labelLinks]="_conf.labelLinks" [_dataLinks]="_conf.dataGlobalLinks"
        class="d_principal d_section_listado d_firstsection onHide" id="listado_dinamico">
    </app-listado-dinamico>

    <!-- Componente que te lleva al inicio de la pagina -->
    <app-ir-arriba class="d_article" />

</section>
<app-footer-krismar id="d_footer" class="d_footer"/>